var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_c('p',[_vm._v("发起支付中,请稍后...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }